<template>
  <hm-content title="">
    <div>
      <div class="g-card">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="170px"
        >
          <div id="base" class="baseTitle mb20">1.基本信息</div>
          <el-form-item label="标签组类型" prop="ruleType">
            <el-select
              v-model="ruleForm.ruleType"
              placeholder="请选择标签组类型"
              :disabled="true"
            >
              <el-option
                v-for="item in ruleTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签组名称" prop="tagName">
            <el-input
              maxlength="120"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.tagName"
              placeholder="请输入标签组名称"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="所属分类" prop="tagCategoryId">
            <el-select
              v-model="ruleForm.tagCategoryId"
              placeholder="请选择所属分类"
            >
              <el-option
                v-for="item in tagGroupList"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="同步到企业微信" prop="wecomTagMappingMode">
            <el-radio-group
              v-model="ruleForm.wecomTagMappingMode"
              class="flex flex-column"
              :disabled="ruleForm.wecomTagMappingModeDisabled"
            >
              <el-radio label="yes" class="radio-lable">
                <span>是</span>
                <div class="form-tips">将该标签组同步到企业微信，同步后不可以取消同步</div>
              </el-radio>
              <el-radio label="no" class="radio-lable">
                <span>否</span>
                <div class="form-tips">
                  该标签组不同步到企业微信

                  {{ruleForm.wecomTagMappingMode}}
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="人群创建条件展示" prop="showGroup">
            <el-radio-group v-model="ruleForm.showGroup">
              <el-radio label="yes">展示</el-radio>
              <el-radio label="no">不展示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="人群创建条件分类" prop="sysCategoryFrontendDisplayId">
            <el-select
              v-model="ruleForm.sysCategoryFrontendDisplayId"
              placeholder="请选择人群创建条件分类"
            >
              <el-option
                v-for="item in tagGroupList2"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分群展示形式" prop="showTypeList">
            <!-- <el-checkbox-group v-model="showTypeList" @change="showTypeChange">
              <el-checkbox
                v-for="(v, i) in groupList"
                :label="v.value"
                :key="i"
                >{{ v.name }}</el-checkbox
              >
            </el-checkbox-group> -->
            <el-radio-group v-model="ruleForm.showType">
              <el-radio :label="v.value" v-for="(v, i) in groupList" :key="i" :disabled="v.disabled">{{v.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择模式" prop="selectMode">
            <el-radio-group v-model="ruleForm.selectMode">
              <el-radio label="single">单选</el-radio>
              <el-radio label="multiple">多选</el-radio>
            </el-radio-group>
          </el-form-item>
          <div id="base" class="baseTitle mb20">
            2.<span v-if="ruleForm.ruleType === 'multiColumns'">字段配置</span>
              <span v-else>标签设置</span>
          </div>
          <el-form-item label="字段设置：" prop="tagList" v-if="ruleForm.ruleType === 'multiColumns'">
            <el-button class="button-new-tag" size="mini" @click="showInputMultiColumns">
              +添加字段
            </el-button>
            <div class="tagList mt10" v-if="multiColumnsList && multiColumnsList.length">
              <div class="tagItem" v-for="(v, i) in multiColumnsList" :key="i">
                <span
                  class="frontViewName"                  
                  >{{ v.labelName }}</span
                >
                <span
                  class="hmicon icon-guanbi1 ml10 pointer"
                  @click="removeTagMultiColumns(v, i)"
                ></span>
                <span class="ml10">|</span>
                <span
                  class="iconfontScrm icon-icon-edit ml10 blue pointer"
                ></span>
                <span class="blue ml5 pointer" @click="editTagMultiColumns(v)">编辑</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="标签设置：" prop="tagList" v-else>
            <el-button class="button-new-tag" size="mini" @click="showInput">
              +添加标签
            </el-button>
            <div class="tagList mt10" v-if="tagList && tagList.length">
              <div class="tagItem" v-for="(v, i) in tagList" :key="i">
                <span
                  class="frontViewName"
                  :style="{ 'background-color': v.dataColor }"
                  >{{ v.frontViewName }}</span
                >
                <span
                  class="hmicon icon-guanbi1 ml10 pointer"
                  @click="removeTag(v, i)"
                  v-if="ruleForm.ruleType === 'static'"
                ></span>
                <span class="ml10">|</span>
                <span
                  class="iconfontScrm icon-icon-edit ml10 blue pointer"
                ></span>
                <span class="blue ml5 pointer" @click="editTag(v)">编辑</span>
              </div>
            </div>
          </el-form-item>

          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >确定
            </el-button>
            <el-button size="small" @click="goBack">返回</el-button>
          </div>
        </el-form>
      </div>

      <el-dialog
        :title="(type === 'edit' ? '修改' : '添加') + '标签'"
        class="create-tag-drawer"
        :visible.sync="tagVisble"
        width="800px"
        :close-on-click-modal="false"
      >
        <el-form
          label-width="140px"
          :model="ruleFormTag"
          :rules="rulesTag"
          ref="ruleFormTag"
          @submit.native.prevent
        >
          <el-form-item label="标签名称" prop="frontViewName">
            <el-input
              maxlength="120"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.frontViewName"
              placeholder="请输入标签组名称"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item label="标签颜色" prop="dataColor">
            <!-- <el-color-picker
              :predefine="predefine"
              v-model="ruleFormTag.dataColor"
              size="mini"
            ></el-color-picker> -->
            <div class="color-list flex item-center">
              <div
                class="color-item"
                :style="{ 'background-color': v }"
                :class="{ 'color-on': ruleFormTag.dataColor === v }"
                v-for="(v, i) in colorList"
                :key="i"
                @click="colorChange(v)"
              ></div>
            </div>
          </el-form-item>

          <el-form-item label="标签描述" prop="dataDesc">
            <el-input
              style="width: 400px"
              type="textarea"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.dataDesc"
              placeholder="请输入标签描述"
              show-word-limit
              maxlength="200"
            ></el-input>
          </el-form-item>

          <el-form-item label="标签排序" prop="sortNum">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.sortNum"
              placeholder="请输入标签排序"
              show-word-limit
              maxlength="6"
              @input="filterGt0Tag('sortNum')"
            ></el-input>
          </el-form-item>

          <el-form-item label="索引后缀日期类型" prop="indexSuffixDateType" v-if="ruleForm.ruleType === 'dynamics'">
            <el-select
              v-model="ruleFormTag.indexSuffixDateType"
              placeholder="请选择索引后缀日期类型"
            >
              <el-option
                v-for="item in indexSuffixDateTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="数据运作模式" prop="dataRunningMode" v-if="ruleForm.ruleType === 'dynamics'">
            <el-select
              v-model="ruleFormTag.dataRunningMode"
              placeholder="请选择数据运作模式"
            >
              <el-option
                v-for="item in dataRunningModeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="执行索引名" prop="runningIndexName" v-if="ruleForm.ruleType === 'dynamics'">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.runningIndexName"
              placeholder="请输入执行索引名"
            ></el-input>
          </el-form-item>
          <el-form-item label="计算规则" prop="queryDetailDsl" v-if="ruleForm.ruleType === 'dynamics' && ruleFormTag.dataRunningMode === 'query'">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.queryDetailDsl"
              placeholder="请输入计算规则"
              type="textarea"
            ></el-input>
            <div class="lineHight16" v-if="ruleFormTag.queryDetailDsl">
            <pre v-highlight>
                <code class="lang-javascript">{{ ruleFormTag.queryDetailDsl }}</code>
            </pre>
            </div>
          </el-form-item>
          <el-form-item label="统计规则" prop="queryCountDsl" v-if="ruleForm.ruleType === 'dynamics' && ruleFormTag.dataRunningMode === 'query'">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.queryCountDsl"
              placeholder="请输入统计规则"
              type="textarea"
            ></el-input>
            <div class="lineHight16" v-if="ruleFormTag.queryCountDsl">
                <pre v-highlight>
                    <code class="lang-javascript">{{ ruleFormTag.queryCountDsl }}</code>
                </pre>
            </div>
          </el-form-item>

          <el-form-item label="抽取周期更新模式" prop="extractCycleUpdateMode" v-if="ruleForm.ruleType === 'dynamics' && ruleFormTag.dataRunningMode === 'extract'">
            <el-select
              v-model="ruleFormTag.extractCycleUpdateMode"
              placeholder="请选择抽取周期更新模式"
            >
              <el-option
                v-for="item in extractCycleUpdateModeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="抽取数据dsl" prop="extractDataDsl" v-if="ruleForm.ruleType === 'dynamics' && ruleFormTag.dataRunningMode === 'extract'">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.extractDataDsl"
              placeholder="请输入抽取数据dsl"
              type="textarea"
            ></el-input>
            <div class="lineHight16" v-if="ruleFormTag.extractDataDsl">
            <pre v-highlight>
                <code class="lang-javascript">{{ ruleFormTag.extractDataDsl }}</code>
            </pre>
            </div>
          </el-form-item>
          <el-form-item label="抽取结果字段名" prop="extractResultFieldName" v-if="ruleForm.ruleType === 'dynamics' && ruleFormTag.dataRunningMode === 'extract'">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormTag.extractResultFieldName"
              placeholder="请输入抽取结果字段名"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tagVisble = false">取 消</el-button>
          <el-button type="primary" @click="ruleFormTagSubmit('ruleFormTag')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        width="700px"
        :title="innerTitle"
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form
          :model="ruleFormField"
          :rules="rulesField"
          ref="ruleFormField"
          label-width="130px"
        >
          <el-form-item label="列名称" prop="labelName">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.labelName"
              placeholder="请输入列名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="对应列字段名" prop="columnName">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.columnName"
              placeholder="请输入列名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="关联字典编码" prop="componentCode">
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.componentCode"
              placeholder="请输入关联字典编码"
            ></el-input>
            <div class="danger" style="line-height:20px;"></div>
          </el-form-item>
          <el-form-item label="执行索引名" prop="runningIndexName">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormField.runningIndexName"
              placeholder="请输入执行索引名"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否必填" prop="requiredQuery">
            <el-select
              v-model="ruleFormField.requiredQuery"
              placeholder="请选择"
              style="width: 400px"
            >
              <el-option
                v-for="item in requiredQueryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段类型" prop="columnType">
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.columnType"
              ref="columnType"
              @change="columnTypeChange"
            >
              <el-option
                v-for="(v, i) in columnList"
                :key="i"
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="查询模式"
            prop="queryMode"
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.queryMode"
              ref="queryMode"
            >
              <el-option
                v-for="(v, i) in modeList"
                :key="i"
                :disabled="
                  (v.itemValue === 'range' &&
                    ruleFormField.columnType === 'strings') ||
                    (v.itemValue === 'like' &&
                      ruleFormField.columnType === 'integer') ||
                    (ruleFormField.columnType === 'datetime' &&
                      (v.itemValue === 'single' ||
                        v.itemValue === 'multiple' ||
                        v.itemValue === 'like'))
                "
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="默认值"
            prop="datetimeRangeType"
            v-if="
              (ruleFormField.columnType === 'date' &&
                ruleFormField.queryMode === 'range' )||
              (ruleFormField.columnType === 'datetime' &&
                ruleFormField.queryMode === 'range' )
            "
          >
            <el-select
              size="small"
              style="width:400px"
              v-model="ruleFormField.datetimeRangeType"
              @change="dateTimeRangeTypeChange"
            >
              <el-option
                v-for="(v, i) in dateTypeList"
                :key="i"
                :label="v.itemText"
                :value="v.itemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="日期时间范围限制"
            prop="datetimeRangeLimit"
            v-if="
              (ruleFormField.columnType === 'date' &&
                ruleFormField.queryMode === 'range' )||
              (ruleFormField.columnType === 'datetime' &&
                ruleFormField.queryMode === 'range' )
            "
          >
            <el-input
              style="width:400px"
              size="small"
              clearable
              class="mr10 ipt"
              @input="filterGt0('datetimeRangeLimit')"
              v-model.trim="ruleFormField.datetimeRangeLimit"
              placeholder="请输入天数"
            ></el-input
            >天
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex flex-center">
          <el-button
            type="primary"
            @click="submitFieldForm('ruleFormField')"
            size="small"
            >确 认</el-button
          >
          <el-button @click="innerVisible = false" size="small"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>

<script>
import { predefine } from "@/utils/tempData";
import { arrayUnique2, getDayAndToday } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      id: "",
      ruleForm: {
        ruleType: "",
        tagName: "",
        tagCategoryId: "",
        sysCategoryFrontendDisplayId: "",
        wecomTagMappingMode: "no",
        showGroup: "yes",
        showType: "pave",
        selectMode: "single",
      },
      rules: {
        tagName: [
          {
            required: true,
            message: '标签组名称是必填项',
            trigger: "blur",
          },
        ],
        tagCategoryId:[
          {
            required: true,
            message: "请选择所属分类",
            trigger: "change",
          }
        ],
      },
      showTypeList: [],
      ruleTypeList: [
        {
          label: "静态标签-自定义标签",
          value: "static",
        },
        {
          label: "动态标签-自定义标签",
          value: "dynamics",
        },
        {
          label: "多字段标签",
          value: "multiColumns",
        },
      ],
      tagGroupList: [],
      tagGroupList2: [],
      tagList: [],
      groupList: [
        {
          name: "平铺选项",
          value: "pave",
          disabled: false,
        },
        {
          name: "下拉框多选",
          value: "combobox",
          disabled: false,
        },
        {
          name: "时间段选择",
          value: "date",
          disabled: true,
        },
        {
          name: "值比较",
          value: "compile",
          disabled: true,
        },
      ],
      tagVisble: false,
      ruleFormTag: {
        frontViewName: "",
        dataColor: "#ED7B2F",
        dataDesc: "",
        sortNum: "",
        queryDetailDsl: "",
        queryCountDsl: "",
        indexSuffixDateType: "",
        dataRunningMode: "",
        runningIndexName: "",
        extractCycleUpdateMode: "",
        extractDataDsl: "",
        extractResultFieldName: "",
      },
      dataRunningModeList:[
        {
          label: "查询",
          value: "query",
        },
        {
          label: "抽取",
          value: "extract",
        },
      ],
      requiredQueryList:[
        {
          label: "是",
          value: "yes",
        },
        {
          label: "否",
          value: "no",
        },
      ],
      extractCycleUpdateModeList:[
        {
          label: "丢弃后续",
          value: "discard",
        },
        {
          label: "覆盖之前",
          value: "overrides",
        },
        {
          label: "增补",
          value: "supplement",
        },
      ],
      indexSuffixDateTypeList:[
        {
          label: "每日",
          value: "daily",
        },
        {
          label: "每月",
          value: "monthly",
        },
      ],
      rulesTag: {
        frontViewName: [
          {
            required: true,
            message: '标签名称是必填项',
            trigger: "blur",
          },
        ],
        dataRunningMode:[
          {
            required: true,
            message: '数据运作模式是必填项',
            trigger: "change",
          },
        ],
        extractCycleUpdateMode:[
          {
            required: true,
            message: '抽取周期更新模式是必填项',
            trigger: "change",
          },
        ],
        indexSuffixDateType:[
          {
            required: true,
            message: '索引后缀日期类型是必填项',
            trigger: "change",
          },
        ],
      },
      predefine,
      type: "",
      tagId: "",
      innerVisible: false,
      innerTitle: "新增字段配置",
      ruleFormField: {
        columnName: "",
        labelName: "",
        queryMode: "",
        columnType: "",
        datetimeRangeLimit: "",
        datetimeRangeType: "",
        componentCode: "",
        runningIndexName: "",
        requiredQuery: "no",
      },
      rulesField: {
        labelName: {
          required: true,
          message: "请输入列名称",
          trigger: "blur"
        },
        whereGroupNum: {
          required: true,
          message: "请选择查询分组序号",
          trigger: "blur"
        },
        columnName: [
          {
            required: true,
            message: "请输入列名称",
            trigger: "blur"
          }
        ],
        columnType: {
          required: true,
          message: "请选择字段类型",
          trigger: "blur"
        },
        queryMode: {
          required: true,
          message: "请选择查询模式",
          trigger: "blur"
        },
        aggregateExpression: {
          required: true,
          message: "请输入聚合字段表达式",
          trigger: "blur"
        }
      },
      modeList: [
        {
          itemText: "单选",
          itemValue: "single",
        },
        {
          itemText: "多选",
          itemValue: "multiple",
        },
        {
          itemText: "范围",
          itemValue: "range",
        },
        {
          itemText: "日期范围",
          itemValue: "dateRange",
        },
        {
          itemText: "精确",
          itemValue: "equal",
        },
        {
          itemText: "模糊",
          itemValue: "like",
        },
      ],
      modeList1: [
        {
          itemText: "单选",
          itemValue: "single",
        },
        {
          itemText: "多选",
          itemValue: "multiple",
        },
        {
          itemText: "范围",
          itemValue: "range",
        },
        {
          itemText: "日期范围",
          itemValue: "dateRange",
        },
        {
          itemText: "精确",
          itemValue: "equal",
        },
        {
          itemText: "模糊",
          itemValue: "like",
        },
      ],
      modeList2: [
        {
          itemText: "单选",
          itemValue: "single",
        },
        {
          itemText: "多选",
          itemValue: "multiple",
        },
        {
          itemText: "范围",
          itemValue: "range",
        },
        {
          itemText: "日期范围",
          itemValue: "dateRange",
        },
        {
          itemText: "精确",
          itemValue: "equal",
        },
        {
          itemText: "模糊",
          itemValue: "like",
        },
        {
          itemText: "不等于",
          itemValue: "not_equal",
        },
        {
          itemText: "排除不等于",
          itemValue: "exclude_equal",
        },
      ],
      dateTypeList: [
        // {
        //   itemText: "最近一周",
        //   itemValue: "-7",
        // },
        // {
        //   itemText: "最近1个月",
        //   itemValue: "-30",
        // },
        // {
        //   itemText: "最近3个月",
        //   itemValue: "-90",
        // },
        {
          itemText: "过去",
          itemValue: "-",
        },
        {
          itemText: "未来",
          itemValue: "+",
        },
      ],
      columnList: [
        {
          itemText: "字符",
          itemValue: "strings",
        },
        {
          itemText: "数字",
          itemValue: "integer",
        },
        {
          itemText: "日期",
          itemValue: "date",
        },
        {
          itemText: "日期时间",
          itemValue: "datetime",
        },
      ],
      multiColumnsList: [],
      parentId: "",
      colorList: [
        "#00A870",
        "#85DBBE",
        "#48C79C",
        "#ED7B2F",
        "#F2995F",
        "#F7C797",
        "#E34D59",
        "#FFA9B0",
        "#E7E7E7",
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.ruleForm.ruleType = this.$route.query.ruleType;
    this.init();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.queryById();
      if(this.ruleForm.ruleType === 'multiColumns'){
        this.queryTagByIdMultiColumns();
      }else{
        this.queryTagById();
      }
    }
  },
  mounted() {
  },
  methods: {
    async init(){
      await this.queryAllTag();
      await this.queryParentId();
      await this.queryAllTag2();
    },
    showInput() {
      this.ruleFormTag = {
        dataRunningMode: "",
        frontViewName: "",
        dataColor: "#ED7B2F",
        dataDesc: "",
        sortNum: "",
        queryDetailDsl: "",
        queryCountDsl: "",
        runningIndexName: "",
        extractCycleUpdateMode: "",
        extractDataDsl: "",
        extractResultFieldName: "",
      };
      this.type = "add";
      this.tagVisble = true;
    },
    showInputMultiColumns(){
      this.ruleFormField = {
        columnName: "",
        labelName: "",
        queryMode: "",
        columnType: "",
        datetimeRangeLimit: "",
        datetimeRangeType: "",
        componentCode: "",
        runningIndexName: "",
      },
      this.type = "add";
      this.innerVisible = true;
    },
    removeTag(row, index) {
      this.$confirm(" 一旦删除之后,该标签下所有关联会员的数据也不再保留,请谨慎操作!!!", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确认删除",
        type: "warning"
      }).then(() => {
        this.tagList.splice(index, 1);
        if (row.id) {
          this.tagRemove(row.id);
        }
      })
    },
    removeTagMultiColumns(row, index) {
      this.$confirm("一旦删除之后,该标签下所有关联会员的数据也不再保留,请谨慎操作!!!", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确认删除",
        type: "warning"
      }).then(() => {
        this.multiColumnsList.splice(index, 1);
        if (row.id) {
          this.tagRemoveMultiColumns(row.id);
        }
      })
    },
    editTag(row) {
      this.type = "edit";
      this.ruleFormTag = row;
      this.tagVisble = true;
      console.log("row:",row);
    },
    editTagMultiColumns(row) {
      this.type = "edit";
      this.ruleFormField = row;
      this.innerVisible = true;
      if(row.columnType === 'strings'){
        this.modeList = this.modeList2;
      }else{
        this.modeList = this.modeList1;
      }
      console.log("row:",row);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {};
          let url = "tagBasicInfoAdd";
          if (this.id) {
            url = "tagBasicInfoEdit";
          }
          let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          Object.assign(params, ruleForm);
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              if (this.id) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.goBack();
              } else {
                this.tagId = res.result.id;
                if(this.ruleForm.ruleType === 'multiColumns'){
                  this.addTagListMultiColumns();
                }else{
                  this.addTagList();
                }
              }
            }
          });
        }
      });
    },
    async addTagList() {
      const params = {
        tagId: this.tagId,
        tagDataRangeConfigList: this.tagList,
      };
      const { code } = await this.$store.dispatch(
        "batchAddTagDataRangeConfigList",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.goBack();
      }
    },
    async addTagListMultiColumns() {
      const params = {
        tagId: this.tagId,
        tagDataColumnConfigList: this.multiColumnsList
      };
      const { code } = await this.$store.dispatch(
        "batchAddTagDataColumnConfigList",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.goBack();
      }
    },
    goBack() {
      this.$router.back(-1);
    },
    showTypeChange(val) {
      this.ruleForm.showType = val.toString();
      console.log("this.ruleForm.showType:", this.ruleForm.showType);
    },
    ruleFormTagSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type === "add") {
            this.tagList.push(this.ruleFormTag);
            if (this.id) {
              this.tagAdd();
            } else {
              this.tagVisble = false;
            }
          }
          if (this.type === "edit") {
            if (this.id) {
              this.tagEdit();
            } else {
              this.tagVisble = false;
            }
          }
        }
      });
    },
    async tagAdd() {
      const params = {
        tagId: this.id,
      };
      Object.assign(params, JSON.parse(JSON.stringify(this.ruleFormTag)));
      const { code } = await this.$store.dispatch(
        "tagDataRangeConfigAdd",
        params
      );
      if (code === "0") {
        this.tagVisble = false;
        this.queryTagById();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async tagAddMultiColumns() {
      const params = {
        tagId: this.id,
      };
      Object.assign(params, JSON.parse(JSON.stringify(this.ruleFormField)));
      const { code } = await this.$store.dispatch(
        "tagDataColumnConfigAdd",
        params
      );
      if (code === "0") {
        this.innerVisible = false;
        this.queryTagByIdMultiColumns();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async tagEdit() {
      const params = JSON.parse(JSON.stringify(this.ruleFormTag));
      const { code } = await this.$store.dispatch(
        "tagDataRangeConfigEdit",
        params
      );
      if (code === "0") {
        this.tagVisble = false;
        this.queryTagById();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async tagEditMultiColumns() {
      const params = JSON.parse(JSON.stringify(this.ruleFormField));
      const { code } = await this.$store.dispatch(
        "tagDataColumnConfigEdit",
        params
      );
      if (code === "0") {
        this.innerVisible = false;
        this.queryTagByIdMultiColumns();
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async tagRemove(id) {
      const params = {
        id,
      };
      const { code } = await this.$store.dispatch(
        "tagDataRangeConfigRemoveByModel",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async tagRemoveMultiColumns(id) {
      const params = {
        id,
      };
      const { code } = await this.$store.dispatch(
        "tagDataColumnConfigRemoveByModel",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    },
    async queryAllTag() {
      const { result } = await this.$store.dispatch(
        "tagCategoryInfoQueryPageList",
        {
          parentId: 1,
          level: 1,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagGroupList = result.records;
    },
    async queryParentId(){
      const { result } = await this.$store.dispatch(
        "sysCategoryFrontendDisplayInfoQueryByName",
        {
          categoryName: "人群筛选器根节点",          
        }
      );
      if(result){
        this.parentId = result.id;
      }
    },
    async queryAllTag2() {
      const { result } = await this.$store.dispatch(
        "querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId",
        {
          parentId: this.parentId,
          level: 1,
          pageNo: 1,
          pageSize: 9999,
        }
      );
      this.tagGroupList2 = result.records;
    },
    async queryById() {
      const { result } = await this.$store.dispatch(
        "tagBasicInfoQueryQueryById",
        {
          id: this.id,
        }
      );
      if (result) {
        this.ruleForm = result;
        if(this.ruleForm.wecomTagMappingMode === 'yes'){
          this.ruleForm.wecomTagMappingModeDisabled = true
        }else{
          this.ruleForm.wecomTagMappingModeDisabled = false
        }
        // if (this.ruleForm.showType) {
        //   this.showTypeList = this.ruleForm.showType.split(",");
        // }
      }
    },
    async queryTagById() {
      const { result } = await this.$store.dispatch(
        "queryTagBasicInfoAndDataRangeConfigListByTagBasicId",
        {
          id: this.id,
        }
      );
      if (result) {
        if (result.tagDataRangeConfigList) {
          this.tagList = result.tagDataRangeConfigList;
          this.tagList  = this.tagList.sort(this.sortBy('sortNum')) 
        }
      }
    },
    async queryTagByIdMultiColumns() {
      const { result } = await this.$store.dispatch(
        "queryTagBasicInfoAndDataColumnConfigListByTagBasicId",
        {
          id: this.id,
        }
      );
      if (result) {
        console.log("result：",result);
        if (result.tagDataColumnConfigList) {
          this.multiColumnsList = result.tagDataColumnConfigList;
          this.multiColumnsList  = this.multiColumnsList.sort(this.sortBy('sortNum'));
          console.log("this.multiColumnsList:",this.multiColumnsList);
        }
      }
    },
    sortBy (field) {
      //根据传过来的字段进行排序,y-x 得分从高到低，x-y 从低到高
      return (x, y) => {
        return  x[field] - y[field]
      }
    },
    // async queryReportMode() {
    //   const { result } = await this.$store.dispatch("queryReportMode");
    //   this.modeList = result;
    // },
    // async querySsrDateType() {
    //   const { result } = await this.$store.dispatch("querySsrDateType");
    //   this.dateTypeList = result;
    // },
    // async queryReportColumn() {
    //   const { result } = await this.$store.dispatch("queryReportColumn");
    //   this.columnList = result;
    // },
    columnTypeChange() {
      this.ruleFormField.queryMode = "";
      if(this.ruleFormField.columnType === 'strings'){
        this.modeList = this.modeList2;
      }else{
        this.modeList = this.modeList1;
      }
    },
    dateTimeRangeTypeChange(val) {
      console.log(getDayAndToday(val));
    },
    filterGt0(prop) {
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(
        /^(0+)|[^\d]+/g,
        ""
      );
      this.ruleFormField[prop] = this.ruleFormField[prop].replace(
        /\.{2,}/g,
        ""
      );
    },
    filterGt0Tag(prop){
      // this.ruleFormTag[prop] = this.ruleFormTag[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormTag[prop] = this.ruleFormTag[prop].replace(
        /[^\d]+/g,
        ""
      );
      this.ruleFormTag[prop] = this.ruleFormTag[prop].replace(
        /\.{2,}/g,
        ""
      );
    },
    submitFieldForm(formName) {
      console.log("this.ruleFormField:",this.ruleFormField);
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleFormField));
          if (this.type === "add") {
            this.multiColumnsList.push(params);
            if (this.id) {
              this.tagAddMultiColumns();
            } else {
              this.innerVisible = false;
            }
          }
          if (this.type === "edit") {
            if (this.id) {
              this.tagEditMultiColumns();
            } else {
              this.innerVisible = false;
            }
          }
          console.log("this.multiColumnsList:",this.multiColumnsList);
        }
      });
    },
    colorChange(color){
      this.ruleFormTag.dataColor = color;
    },
  },
};
</script>
<style lang="scss" scoped>
.baseTitle {
  font-size: 18px;
  border-bottom: solid 1px #e9eef7;
  padding-bottom: 10px;
}
.radio-lable {
  margin-top: 15px;
  .form-tips {
    margin-top: 10px;
    color: #aaaaaa;
  }
}
.tagList {
  background: #f2f5f8;
  padding: 25px;
  .tagItem {
    background: #ffffff;
    padding: 0px 10px;
    border: solid 1px #dcdcdc;
    display: inline-block;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
    .ml5 {
      margin-left: 5px;
    }
    .frontViewName {
      padding: 4px 8px;
      border-radius: 4px;
    }
  }
}
.lineHight16{
  line-height: 16px;
}
.color-list {
  margin-left: 20px;
  .color-item {
    width: 28px;
    height: 28px;
    border: solid 2px #ffffff;
    border-radius: 6px;
    margin-right: 10px;
    padding: 4px;
    cursor: pointer;
  }
  .color-on {
    border: solid 2px #56abee;
  }
}
</style>
